export enum SchedulingType {
  PICKUP = 'pickup',
  DROPOFF = 'dropoff',
}

export interface GenerateShippingParams {
  itemPublicIds: string[];
  addressObj: {
    street: string;
    street2: string;
    city: string;
    state: string;
    zipcode: string;
  };
  user: {
    first_name: string;
    last_name: string;
  };
}
